import {
  SearchSuggestionType,
  LinkTrackingData,
} from '../../../../../../AnalyticsContext/LinkTracking';
import { Practice } from '../../../../../icons/outlined/Practice';
import {
  SuggestionPrimary,
  SuggestionSecondary,
  PracticeIcon,
} from '../SuggestionStyles/SuggestionStyles.styles';
import { SuggestionTemplate } from '../SuggestionTemplate/SuggestionTemplate';

export const PracticeSuggestion = ({
  name,
  specialties,
  suburb,
  state,
  trackingData,
}: {
  name: string;
  specialties: string[];
  suburb: string;
  state: string;
  trackingData: LinkTrackingData;
}) => (
  <SuggestionTemplate
    trackingData={{ ...trackingData, searchSuggestionType: SearchSuggestionType.PRACTICE }}
    visual={
      <PracticeIcon>
        <Practice />
      </PracticeIcon>
    }
    showPracticeVisual={true}
    primary={<SuggestionPrimary>{name}</SuggestionPrimary>}
    secondary={
      <SuggestionSecondary>
        {specialties.slice(0, 3).join(', ')}
        {specialties.length > 3 && ', and more '}
        {(specialties.length && ' - ') || ''}
        {suburb} {state}
      </SuggestionSecondary>
    }
  />
);
